/* eslint-disable eqeqeq */
import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import moment from 'moment';

import {
  Segment,
  Button,
  Modal,
  Icon,
  Popup,
  Tab,
  Form,
} from 'semantic-ui-react';

import { get, isEmpty } from '../../../utils/lodash';
import { CustomTable } from '../../../components';
import { CustomTooltip } from '../../../components';
import { toSqlDate, getPageDisable } from '../../../utils';

import {
  getDocuments,
  deleteDocument,
  postDocument,
  updateDocument,
} from '../../../store/actions';

import {
  CustomFileUpload,
  CustomInput,
  CustomTextArea,
} from '../../../components/form';

import {
  fileDocumentInitialValues,
  fileDocumentValidationSchema,
  linkDocumentInitialValues,
  linkDocumentValidationSchema,
} from '../../../validations/activityDocumentMediaValidation';

import './activity.scss';

class DocumentAndMedia extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      uploaded: false,
      document: '',
      activityDate: moment().format('DD-MM-YYYY'),
      isUploadButtonClicked: false,
    };
  }

  setFile = async (file) => {
    this.setState({ file });
  };

  async handleValidSubmit(event, values, isUpdate, isFileEmpty, isDocument) {
    const { currentActivity } = this.props.activity;
    if (isUpdate) {
      await this.props.updateDocument(
        currentActivity.id,
        this.state.documentId,
        {
          projectId: currentActivity.id,
          description: values.documentDescription,
          // location: values.documentLocation,
          date: toSqlDate(this.state.activityDate),
          documentId: this.state.documentId,
          urlText: values.documentUrlText,
          title: values.documentTitle,
          imageCredit: values.documentImageCredit,
        }
      );

      this.setState({
        isUploadButtonClicked: true,
      });

      this.setState({
        values,
      });
      this.toggle();
    } else {
      if (!isFileEmpty || !isDocument) {
        await this.props.postDocument({
          upload: this.state.file ? this.state.file.file : '',
          projectId: currentActivity.id,
          description: values.documentDescription,
          urlText: values.documentUrlText,
          // location: values.documentLocation,
          date: toSqlDate(this.state.activityDate),
          title: values.documentTitle,
          imageCredit: values.documentImageCredit,
        });

        this.setState({
          values,
        });
        this.toggle();
      }

      this.setState({
        isUploadButtonClicked: true,
      });
    }
  }

  toggle() {
    this.setState((prevState) => ({
      isUpdate: false,
      documentDescription: null,
      documentLocation: null,
      documentUrlText: null,
      documentTitle: null,
      documentImageCredit: null,
      mimeType: null,
      activityDate: moment().format('DD-MM-YYYY'),
      modal: !prevState.modal,
      isUploadButtonClicked: false,
    }));
  }

  onChange(value, type) {
    this.setState({
      [type]: value,
    });
  }

  onEditDocument(values, documentId) {
    this.setState({
      documentDescription: values.documentDescription,
      documentLocation: values.documentLocation,
      documentUrlText: values.documentUrlText,
      documentTitle: values.documentTitle,
      documentImageCredit: values.documentImageCredit,
      mimeType: values.mimeType,
      activityDate: moment(values.date).format('DD-MM-YYYY'),
      isUpdate: true,
      documentId: documentId,
      modal: true,
    });
  }

  render() {
    const { user, helpTips, activity, currentState, t } = this.props;
    return (
      <Segment
        loading={
          activity.getDocumentsLoading || activity.deleteDocumentsLoading
        }
        className="document-media-seg"
      >
        <div className="document-media-div">
          <p>
            {t('activity.documentation.documents_and_media.uploadDescription')}
          </p>
          <CustomTooltip
            state={get(user, 'options.tips')}
            contentObject={{ data: helpTips, key: '57' }}
            position="bottom left"
          >
            <Button
              className="Primary-Button"
              onClick={() => this.toggle()}
              disabled={getPageDisable(
                activity.currentActivity,
                user,
                currentState,
                true
              )}
            >
              {t('activity.documentation.documents_and_media.uploadItems')}
            </Button>
          </CustomTooltip>

          <CreateDocument
            handleValidSubmit={(
              event,
              values,
              isUpdate,
              isFileEmpty,
              isDocument
            ) =>
              this.handleValidSubmit(
                event,
                values,
                isUpdate,
                isFileEmpty,
                isDocument
              )
            }
            isUploadButtonClicked={this.state.isUploadButtonClicked}
            onChange={(value, type) => this.onChange(value, type)}
            setFile={this.setFile}
            modal={this.state.modal}
            toggle={() => this.toggle()}
            state={this.state}
            {...this.props}
          />
        </div>
        <ViewDocuments
          setState={(values, documentId) =>
            this.onEditDocument(values, documentId)
          }
          {...this.props}
        />
      </Segment>
    );
  }
}

class CreateDocument extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      value: {},
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal, toggle, t } = this.props;
    return (
      <div className="add-user">
        <Modal
          size="small"
          open={modal}
          onOpen={() => toggle()}
          closeIcon={
            <Icon onClick={() => toggle()} name="close" className="closeicon" />
          }
          className="upload-media"
        >
          <Modal.Header>
            <label className="upload-media-header">
              {t('activity.documentation.documents_and_media.uploadMedia')}
            </label>
          </Modal.Header>
          <Modal.Content>
            <DocumentForm toggle={() => this.toggle()} {...this.props} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class DocumentForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDocument: true,
      isFileEmpty: true,
    };
  }

  componentDidMount() {
    const { state } = this.props;

    if (state.isUpdate) {
      this.setState({
        isDocument:
          state.isUpdate && isEmpty(state.documentUrlText) ? true : false,
      });
    }
  }

  menuItems(state) {
    this.setState({
      isDocument: state,
    });
  }

  isDocumentEmpty() {
    this.setState({
      isFileEmpty: false,
    });
  }

  renderForm(isUpdate = false, isDocument = true) {
    const { toggle, setFile, handleValidSubmit, activity, state, t } =
      this.props;

    let initialValues = fileDocumentInitialValues(state);
    let validationSchema = fileDocumentValidationSchema(state, t);

    // Image credit only makes sense for an actual image file — new upload:
    // detected from the picked File's own mime type; editing an existing
    // document: from the mime type already recorded against it.
    const isImage = isUpdate
      ? !!state.mimeType && state.mimeType.startsWith('image/')
      : !!state.file?.file?.type && state.file.file.type.startsWith('image/');

    if (!isDocument) {
      initialValues = linkDocumentInitialValues(state);
      validationSchema = linkDocumentValidationSchema(t);
    }

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleValidSubmit('', values, isUpdate, false, isDocument);
        }}
      >
        {({ handleSubmit, isSubmitting, setFieldValue, errors }) => (
          <Form onSubmit={handleSubmit}>
            <CustomInput
              name="documentTitle"
              id="documentTitle"
              labelText={t('formulary.title')}
              placeholder={t('formulary.placeholder.enter_title')}
            />

            {isDocument ? (
              <CustomFileUpload
                id="documentFile"
                name="documentFile"
                labelText={t(
                  'activity.documentation.documents_and_media.document'
                )}
                accept="*"
                buttonText={t(
                  'activity.documentation.documents_and_media.form.browseFile'
                )}
                mediaUpload={true}
                infoMessage={t(
                  'activity.documentation.documents_and_media.form.maxFileSize'
                )}
                setFile={(file) => setFile(file)}
                showMsg={true}
                placeholder={t(
                  'activity.documentation.documents_and_media.form.acceptedFileTypes'
                )}
                restrictedSize={2}
                setFieldValue={setFieldValue}
                loading={
                  activity.postDocumentsLoading ||
                  activity.updateDocumentsLoading
                }
                disabled={
                  activity.postDocumentsLoading ||
                  activity.updateDocumentsLoading
                }
              />
            ) : (
              <CustomInput
                name="documentUrlText"
                id="documentUrlText"
                labelText={t('activity.documentation.documents_and_media.link')}
                placeholder={t(
                  'activity.documentation.documents_and_media.form.enterLink'
                )}
              />
            )}

            <CustomTextArea
              name="documentDescription"
              id="documentDescription"
              placeholder={t('formulary.placeholder.enter_description')}
              labelText={t('common.description')}
            />

            {isDocument && isImage && (
              <CustomInput
                name="documentImageCredit"
                id="documentImageCredit"
                labelText={t('activity.media.image_credit.label')}
                placeholder={t('activity.media.image_credit.placeholder')}
              />
            )}

            <div className="model-buttons">
              <Button
                className="Secondary-Button"
                type="button"
                onClick={() => toggle()}
                disabled={
                  activity.postDocumentsLoading ||
                  activity.updateDocumentsLoading
                }
              >
                {t('actions.cancel')}
              </Button>

              <Button
                className="Primary-Button"
                loading={
                  activity.postDocumentsLoading ||
                  activity.updateDocumentsLoading
                }
                disabled={
                  activity.postDocumentsLoading ||
                  activity.updateDocumentsLoading
                }
                type="submit"
              >
                {!state.isUpdate ? t('actions.upload') : t('actions.save')}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    );
  }

  render() {
    const { state, t } = this.props;

    const panes = (isUpdate = false, documentUrlText = null) => {
      const documentPane = [
        {
          menuItem: t('activity.documentation.documents_and_media.document'),
          render: () => (
            <Tab.Pane key="documentPane" attached={false}>
              {this.renderForm(isUpdate)}
            </Tab.Pane>
          ),
        },
      ];

      const linkPane = [
        {
          menuItem: t('activity.documentation.documents_and_media.link'),
          render: () => (
            <Tab.Pane key="linkPane" attached={false}>
              {this.renderForm(isUpdate, false)}
            </Tab.Pane>
          ),
        },
      ];

      let pane = [];
      if (!isUpdate) {
        pane = documentPane.concat(linkPane);
        return pane;
      } else if (documentUrlText) {
        return linkPane;
      } else {
        return documentPane;
      }
    };

    return (
      <div>
        <Tab
          className="document-custom-tab"
          menu={{ secondary: true, pointing: true }}
          panes={panes(state.isUpdate, state.documentUrlText)}
        />
      </div>
    );
  }
}

class ViewDocuments extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  editDocument(data) {
    const values = {
      documentDescription: data.description,
      documentLocation: data.location,
      date: data.date,
      documentUrlText: data.mediaUrl,
      documentTitle: data.mediaTitle,
      documentImageCredit: data.imageCredit,
      mimeType: data.document ? data.document.mimeType : '',
    };
    this.props.setState(values, data.document.id);
  }

  componentDidMount() {
    const { getDocuments, activity } = this.props;
    getDocuments(activity.currentActivity.id);
  }

  getColumns(activity, user, currentState, t) {
    return [
      {
        title: t('common.name'),
        width: '4',
        render: (data) => {
          return (
            <div className="activity-users-container">
              <label>
                <Popup
                  content={
                    isEmpty(data.mediaUrl)
                      ? data.document.name
                        ? data.document.name.split('.')[0]
                        : data.mediaTitle
                      : data.mediaTitle
                        ? data.mediaTitle
                        : ''
                  }
                  trigger={<div>{data.mediaTitle}</div>}
                />
              </label>
              <br />
              <label className="activity-users-text document-description">
                {data ? data.description : ''}
              </label>
            </div>
          );
        },
      },
      {
        title: t('activity.documentation.documents_and_media.table.format'),
        width: '3',
        render: (data) => {
          return (
            <div>
              {data.document.name === ''
                ? t('activity.documentation.documents_and_media.link')
                : data.document.name.split('.').at(-1)}
            </div>
          );
        },
      },
      {
        title: t('common.date_added'),
        width: '3',
        render: (data) => {
          return (
            <div>
              {data.date ? moment(data.date).format('DD-MM-YYYY') : '-'}
            </div>
          );
        },
      },
      {
        title: '',
        width: '2',
        render: (data) => {
          return (
            <Segment
              disabled={getPageDisable(
                activity.currentActivity,
                user,
                currentState,
                true
              )}
            >
              <label
                onClick={() => this.editDocument(data)}
                className="activity-actions-warn mb-0"
              >
                {t('actions.edit')}
              </label>
            </Segment>
          );
        },
      },
      {
        title: '',
        width: '2',
        render: (data) => {
          return (
            <div>
              {isEmpty(data.mediaUrl) ? (
                <label className="activity-actions-warn mb-0">
                  <a
                    className="activity-actions-warn download-button"
                    href={`${data.document.documentUrl}`}
                    rel="noopener noreferrer"
                    download
                    target="_blank"
                  >
                    {t('actions.download')}
                  </a>
                </label>
              ) : (
                <div className="link-button-document">
                  <CopyToClipboard
                    text={data.mediaUrl}
                    onCopy={() =>
                      NotificationManager.info(
                        t(
                          'activity.documentation.documents_and_media.notifications.copiedToClipboard'
                        ),
                        t(
                          'activity.documentation.documents_and_media.notifications.documentLink'
                        )
                      )
                    }
                  >
                    <div className="copy-link-warn">
                      {t('actions.copy_link')}
                    </div>
                  </CopyToClipboard>
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: '',
        width: '2',
        render: (data) => {
          return (
            <div className="disabled-padding">
              <Segment
                disabled={getPageDisable(
                  activity.currentActivity,
                  user,
                  currentState,
                  true
                )}
              >
                <DocumentDelete document={data} {...this.props} />
              </Segment>
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { activity, user, currentState, t } = this.props;
    return (
      <Segment className="program-activities">
        <div className="scroll-table">
          <CustomTable
            header
            columns={this.getColumns(activity, user, currentState, t)}
            data={activity.documents}
            customClass="program-activities-table"
            emptyMessage={t(
              'activity.documentation.documents_and_media.table.emptyMessage'
            )}
            keyExtractor={(item, index) => item.id}
          />
        </div>
      </Segment>
    );
  }
}

class DocumentDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async deleteDocument(id) {
    try {
      const { deleteDocument, activity } = this.props;
      await deleteDocument(activity.currentActivity.id, id);
      this.toggle();
    } catch (error) {}
  }

  render() {
    const { modal } = this.state;
    const { document, activity, t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label className="activity-actions-error first-down mb-0">
            {t('actions.remove')}
          </label>
        }
      >
        <Modal.Header className="delete-media-header">
          {t('activity.documentation.documents_and_media.delete.title')} -{' '}
          {document.document.name
            ? document.document.name
            : document.mediaTitle}
        </Modal.Header>
        <Modal.Content>
          <p>
            {t(
              'activity.documentation.documents_and_media.delete.confirmation'
            )}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button className="modal-cancel" onClick={() => this.toggle()}>
            {t('actions.no')}
          </Button>
          <Button
            className="modal-proceed"
            loading={activity.deleteDocumentsLoading}
            disabled={activity.deleteDocumentsLoading}
            onClick={() => this.deleteDocument(document.document.id)}
          >
            {t('actions.yes')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activity: state.activity,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
    documents: state.activity.documents,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDocuments,
      deleteDocument,
      postDocument,
      updateDocument,
    },
    dispatch
  );
};

DocumentAndMedia = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(DocumentAndMedia));

export { DocumentAndMedia };
